import classNames from 'classnames';

import type { FC, PropsWithChildren } from 'react';
import React from 'react';

import styles from './styles.module.scss';

interface LabelTextProps {
  htmlFor: string,
  required?: boolean,
  error?: string,
  isActive?: boolean,
  inTop?: boolean,
  small?: boolean,
  disabled?: boolean,
}

const LabelText: FC<PropsWithChildren<LabelTextProps>> = ({
  children,
  htmlFor,
  required,
  error,
  isActive,
  inTop,
  small,
  disabled,
}) => {
  const cn = classNames(
    styles.labelText,
    error && styles.error,
    isActive && styles.active,
    inTop && styles.inTop,
    small && styles.small,
    disabled && styles.disabled,
  );
  return (
    <label htmlFor={htmlFor} className={cn}>
      {children}
      {required && (
        <span>{' *'}</span>
      )}
    </label>
  );
};

export default LabelText;
